import React, { useState } from 'react';

import DromoImporterButton from 'components/dromo/importer_button';
import Imports from 'bundles/crm/imports/components/imports';
import Modal from 'components/modal';
import { getDromoImporterConfig, groupId } from './config';
import { usePollingImports } from 'components/dromo/hooks';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { DromoImporterProps } from 'components/dromo/types';

interface Props {
  customFields: CustomField[];
  dromoImporterProps: DromoImporterProps;
  show?: boolean;
  onHide: (refresh: boolean) => void;
}

export default function PropertiesImports({
  customFields,
  dromoImporterProps,
  show,
  onHide,
}: Props) {
  const [imports, addImport] = usePollingImports(groupId, show);
  const [hasImported, setHasImported] = useState(false);
  const [showDromo, setShowDromo] = useState(false);

  const handleImport = (newImport) => {
    setShowDromo(false);
    addImport(newImport);
    setHasImported(true);
  };

  const importButton = (
    <DromoImporterButton
      dromoImporterConfig={getDromoImporterConfig(customFields)}
      dromoImporterProps={dromoImporterProps}
      setShowDromo={setShowDromo}
      showDromo={showDromo}
      showIcon
      onCreate={handleImport}
    />
  );

  return (
    <Modal show={show} size="lg" onHide={() => onHide(hasImported)} onShow={() => setHasImported(false)}>
      <Modal.Header closeButton>Import Properties</Modal.Header>
      <Imports importButton={importButton} imports={imports} onClick={() => setShowDromo(true)}/>
    </Modal>
  );
}
